import { User } from '../types/User';

export const initials = (user: User): string => `${user.first_name[0]}${user.last_name[0]}`;
